const allLinks = {
  twitterLink: 'https://twitter.com/AngryWomenNFT',
  discordLink: 'https://discord.gg/CznaBtYYr3',
  instagramLink: 'https://www.instagram.com/angrywomennft/',
  openseaLink: 'https://opensea.io/collection/angrywomengenesis',
  toolLink: 'http://verygoodtool.xyz',
  amountOfNfts: ''
}

export default allLinks